export default "__VITE_ASSET__DfA8kOAQ__"